import axios from "axios";
import { useDispatch } from "react-redux";
import { setUserRole,setUserStep } from "../../Redux/userSlice";



export const markDonor = async (dispatch)=>{
    
    try{
        
        const response = await axios.patch(`${import.meta.env.VITE_API_URL}/user/donor`);
        console.log(response)
        dispatch(setUserRole("user"))
        dispatch(setUserStep("2"))
        return response.data;

    }catch(error){

        console.log(error)
        throw error;
    }
}

